import { create } from 'zustand';
import type { Map as MapboxMap } from 'mapbox-gl';
import type { Station } from '@/types/domain';

interface MapStore {
  mapInstance: MapboxMap | null;
  setMapInstance: (map: MapboxMap | null) => void;
  visibleStations: Station[];
  setVisibleStations: (stations: Station[]) => void;
}

export const useMapStore = create<MapStore>((set) => ({
  mapInstance: null,
  setMapInstance: (mapInstance) => set({ mapInstance }),
  visibleStations: [],
  setVisibleStations: (visibleStations) => set({ visibleStations }),
}));
